import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepButton,
  StepLabel,
  Typography,
  LinearProgress,
  useTheme,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function StepNav({ steps, activeStep, onStepClick }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const completedCount = steps.filter(s => s.completed).length;
  const progressPct = (completedCount / steps.length) * 100;

  return (
    <Box
      sx={{
        width: 240,
        minWidth: 240,
        borderRight: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        gap: 3,
      }}
    >
      <Box>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {t('onboarding:step_nav.progress', { completed: completedCount, total: steps.length })}
        </Typography>
        <LinearProgress
          variant="determinate"
          value={progressPct}
          sx={{ borderRadius: 1, height: 6 }}
        />
      </Box>

      <Stepper
        activeStep={activeStep}
        orientation="vertical"
        nonLinear
        sx={{
          '& .MuiStepConnector-line': { minHeight: 16 },
        }}
      >
        {steps.map((step, index) => (
          <Step key={step.id} completed={step.completed}>
            <StepButton
              onClick={() => onStepClick(index)}
              icon={
                step.completed ? (
                  <CheckCircle color="success" sx={{ fontSize: 24 }} />
                ) : undefined
              }
            >
              <StepLabel
                sx={{
                  '& .MuiStepLabel-label': {
                    fontWeight: activeStep === index ? 700 : 400,
                    color:
                      activeStep === index
                        ? theme.palette.primary.main
                        : undefined,
                  },
                }}
              >
                {step.label}
              </StepLabel>
            </StepButton>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
